import { Account } from '@/client/accounts';
import { useLanguageFailureNotices } from '@/hooks/query/campaigns.hook';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useToast } from '@/hooks/useToast';
import { PostHogFeatureFlags } from '@/utils/posthog';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const useLanguageFailureToasts = (account?: Account): void => {
  const { t } = useTranslation();
  const toast = useToast();
  const { accountCanUseFeature } = useFeatureFlag();
  const shownNoticeIdsRef = useRef(new Set<string>());

  const isLanguageTargetingActive =
    !!account &&
    !account.isSystem &&
    accountCanUseFeature(
      PostHogFeatureFlags.SMART_LANGUAGE_TARGETING,
      account.featureFlagAbility ?? [],
    ) &&
    accountCanUseFeature(
      PostHogFeatureFlags.PHISHING_TEMPLATE_LEVEL_VIEW,
      account.featureFlagAbility ?? [],
    );

  const { notices } = useLanguageFailureNotices(
    account?.id,
    isLanguageTargetingActive,
  );

  useEffect(() => {
    notices?.forEach((notice) => {
      if (shownNoticeIdsRef.current.has(notice.id)) return;
      shownNoticeIdsRef.current.add(notice.id);
      toast?.error(
        t('phishing.simulations.languageGroupFailed.title'),
        t('phishing.simulations.languageGroupFailed.body', {
          name: notice.simulationName,
        }),
      );
    });
  }, [notices]);
};
